module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi9fRWxlbWVudEluc3BlY3Rvcic7CgouTGFuZ3VhZ2VzTGlzdEluc3BlY3RvciB7CiAgdG9wOiAtMzBweDsKICBoZWlnaHQ6IDEyNXB4OwogIHdpZHRoOiAxNTBweDsKICBsZWZ0OiA1MCU7CiAgbWFyZ2luLWxlZnQ6IC03NXB4OwoKICAmLmhpZGRlbiB7CiAgICB0b3A6IC0yNXB4OwogIH0KCiAgaW5wdXRbdHlwZT0nY2hlY2tib3gnXSB7CiAgICBtYXJnaW4tcmlnaHQ6IDEwcHg7CiAgfQoKICBpbnB1dFt0eXBlPSd0ZXh0J10gewogICAgb3V0bGluZTogbm9uZTsKICAgIGJvcmRlcjogMDsKICAgIHBhZGRpbmc6IDJweDsKICB9Cn0K"


//////////////////
// WEBPACK FOOTER
// ./src/components/inspect/LanguagesListInspector.scss
// module id = 651
// module chunks = 0